import React from 'react';

import { hourlyTrackerLink } from 'scenes/Trackers/HourlyTracker/navigation';
import {
  baseCompareSchema,
  compareSchema,
} from 'scenes/Trackers/HourlyTracker/schemas';
import WidgetActions from 'scenes/Trackers/components/Widget/WidgetActions';

const HourlyTrackerPresetActions = () => {
  const handleCompare = (baseFilters) => [
    baseCompareSchema.cast(baseFilters, { stripUnknown: true }),
    compareSchema.cast(baseFilters, { stripUnknown: true }),
  ];

  return <WidgetActions link={hourlyTrackerLink} onCompare={handleCompare} />;
};

export default HourlyTrackerPresetActions;
